import { Component, OnInit }            from '@angular/core';
import { AuthService }                  from '../../../providers/auth.service';
import { Router }                       from '@angular/router';
import { User }                         from '../../models/user';
import { RoleService}                   from '../../services/role.service';
import { Role }                         from '../../models/role';
import { UserService }                  from '../../services/user.service';
import { Subject }                      from 'rxjs/Subject';
import { LaddaModule }                  from 'angular2-ladda';

@Component({
  selector: 'user-list',
  templateUrl: 'user-list.component.html',
  styleUrls: ["user-list.component.scss"]
})

export class UsersListComponent implements OnInit  {

  private users: User[] = [];
  private user: User;
  private roles: any[] = [];
  private selectedRoles: any[];
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private userService: UserService,
    private roleService: RoleService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.authService.getUser().subscribe(user => {
      if(!user) {
        this.router.navigate(["/login"])
      } else {
        this.user = user;
        this.roleService.getRoles().subscribe(roles => {
          this.roles = roles;
          this.userService.getUsers()
            .subscribe(users => {
              this.users = users
            });
        });
      }
    })
  }

  getRoleById(id) {
    for (var i in this.roles)
      if (this.roles[i].id == id)
        return this.roles[i];
    return null;
  }

  refresh() {
    window.location.reload();
  }

  formatRoles(user){
    return user.roles.map(id => this.getRoleById(id).name).join(',');
  }

  delete(e, user: User)
  {
    e.stopPropagation();
    this.userService.delete(user).subscribe( () => this.refresh())
  }

  habilitated(e, user: User)
  {
    e.stopPropagation();
    this.userService.habilitated(user).subscribe( () => this.refresh())
  }
}



// WEBPACK FOOTER //
// ./src/app/users/components/users-list/user-list.component.ts